import buildClient from '@/api/client'
import getMiniCartQuery from '@/api/mini-cart'
import getOrderAdjustment from '@/api/order-adjustment'
import getCartItemsQuery from '@/api/cart-items'
import getStoreQuery from '@/api/store'
import applyPromotionToCurrentOrderQuery from '@/api/apply-promotion-to-current-order'
import removePromotionFromCurrentOrderQuery from '@/api/remove-promotion-from-current-order'

export function fetchMiniCart() {
  return buildClient().query(getMiniCartQuery())
}

export function fetchStore() {
  return buildClient().query(getStoreQuery())
}

export function fetchCartItems(ids) {
  return buildClient()
    .query(getCartItemsQuery(), {
      ids,
    })
    .then(data => data.variants)
}

export function applyPromotionToCurrentOrder(promoCode) {
  return buildClient().query(applyPromotionToCurrentOrderQuery(promoCode))
}
export function removePromotionFromCurrentOrder(promoCode) {
  return buildClient().query(removePromotionFromCurrentOrderQuery(promoCode))
}
export function fetchAdjustmentFromCurrentOrder() {
  return buildClient().query(getOrderAdjustment())
}
